import React from "react"
import { useTranslation } from "react-i18next"

const LoadingScreen = (props) => {

    const { t } = useTranslation()

    return <section
    className="hero is-fullheight has-text-centered has-background-success"
    style={{ width: '100%' }}
>
    <div className="hero-body">
        <div className="container p-0 has-text-centered">
            <img
                src="https://firebasestorage.googleapis.com/v0/b/public-contents.appspot.com/o/SHYFTBASE%2FShyftBase-Logo-A.png?alt=media&token=1d864aae-feaf-4564-a00d-b9af22807695"
                alt="Shyftbase logo"
                width={250}
            />
            <p className="title  has-text-white">{t('loadingMessage')}</p>
            <p className="subtitle  has-text-white is-6">{t('loadingMessage2')}</p>
            <p className="subtitle  has-text-white is-6 my-3">{t('loading')}</p>
        </div>
    </div>
</section>
}

export default React.memo(LoadingScreen)
